// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1993":"45fa531c","4318":"45fa531c","5979":"4a3075ef","8557":"22ac37d2"}[chunkId] + ".chunk.css";
};